import { createTheme, ThemeProvider } from '@mui/material/styles';

import Routes from 'src/Routes';
import { COLORS } from 'src/constants';
import { AuthProvider } from 'src/contexts';

const outerTheme = createTheme({
  palette: {
    primary: {
      main: COLORS.primary,
    },
    secondary: {
      main: COLORS.secondary,
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={outerTheme}>
      <AuthProvider>
        <Routes />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
